import { ServicingRole, ServicingRoleForUpdate, AllowedUserForServicingRole } from '@/types/v2/Policy';
import { isAxiosError, Service } from '../api';
import { AxiosResponse } from 'axios';
import { AuditLog } from '@/types/AuditLog';

class PolicyService extends Service {
  async getPolicyLineServicingRoles(policyID: number): Promise<ServicingRole[]> {
    return this.get<ServicingRole[]>('/v2/policy-line-servicing-roles', { policyID }).then(this.handleResponse);
  }

  async updatePolicyLineServicingRoles(policyID: number, servicingRoles: ServicingRoleForUpdate[]): Promise<AxiosResponse> {
    const response = await this.post('/v2/policy-line-servicing-roles', { policyID: policyID, roles: servicingRoles });

    if (isAxiosError(response)) {
      throw new Error(`Failed to update servicing roles: ${response.message}`);
    }

    return response
  }

  async getPolicyLineServicingRolesAuditHistory(policyID: number): Promise<AuditLog[]> {
    return this.get<AuditLog[]>('/v2/policy-line-servicing-roles-audit-history', { policyID })
      .then(this.handleResponse);
  }

  async getAllowedUsersForServicingRoles(): Promise<AllowedUserForServicingRole[]> {
    return this.get<AllowedUserForServicingRole[]>('/v2/allowed-users-for-servicing-roles', {})
      .then(this.handleResponse);
  }
}

export const policyService = new PolicyService();
